export default __webpack_public_path__ + "static/GT-America-Extended-Bold-17b186960c4c580bfc78736e09c222d8.woff";